import { ReactElement } from 'react';

import { useTheme, useMediaQuery } from '@mui/material';

import { SpinnerProps } from './types';

import commonProps from '../../common/props';

export default function Spinner({ onEnded }: SpinnerProps): ReactElement {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <video
      {...commonProps}
      onEnded={onEnded}
      style={{ objectFit: 'cover', display: 'block', margin: '0 auto' }}>
      <source
        src={`https://cdn.tain.com/amazing/video/spinner-${isXs ? 'mob' : 'desktop'}.mp4`}
        type='video/mp4'
      />
      <track kind='captions' />
    </video>
  );
}
